import introImage from '@volumental/assets/images/Hybrid/ScanningIntro.png';
import { Container } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../../components/accessible-components';
import { MidJourneyIntro } from './mid-journey-intro';

interface ScannerIntroProps {
  onClose: () => void;
  onBack: () => void;
  onContinue: () => void;
  onSkip?: () => void;
}
export function ScannerIntro({
  onBack,
  onClose,
  onContinue,
  onSkip,
}: ScannerIntroProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Container>
      <Header close={onClose} back={onBack} />
      <MidJourneyIntro
        onClick={onContinue}
        title={t('hybrid.scannerIntro.title')}
        subTitle={t('hybrid.scannerIntro.subtitle')}
        buttonText={t('hybrid.scannerIntro.letsScan')}
        imageSrc={introImage}
        skipButtonText={t('button.skipForNow')}
        onSkip={onSkip}
      />
    </Container>
  );
}
